import Swiper, { Autoplay } from 'swiper'

import './clients.scss'

const initClientsSwiper = () => {
  new Swiper('.clients__swiper.swiper', {
    modules: [Autoplay],
    slidesPerView: 2,
    spaceBetween: 24,
    loop: true,

    speed: 2000,

    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },

    breakpoints: {
      768: {
        slidesPerView: 4,
        spaceBetween: 56,
      },
    },
  })
}

document.addEventListener('DOMContentLoaded', async function () {
  initClientsSwiper()
})
